import { Component, OnInit } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { CookieService } from 'src/app/core/services/cookie.service';

@Component({
  selector: 'app-cookie',
  templateUrl: './cookie.component.html',
  styleUrls: ['./cookie.component.scss']
})

export class CookieComponent implements OnInit {
  data: any;

  constructor(
    private translate: TranslateService,
    private cookieService: CookieService
  )
    {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.carregarDados();
    });
  }

  ngOnInit() {
    this.carregarDados();
  }

  carregarDados() {
    this.translate.get('COOKIE').subscribe(res => {
      this.data = res;
    });
  }

  gravaCookieConsent() {
    this.cookieService.setCookieConsent();
  }
}
